export const OWNERSHIP_TYPES = {
  SHARED: 1,
  PRIVATE: 2,
};
